var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230,
    height: 60,
    viewBox: "0 0 230 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.71 0 0 0.78 115.19 30.19)",
    id: "HUFNjOCyqvpWQNsR10qUD"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.92,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -159.5 37.154 L -159.5 -37.154 L 159.5 -37.154 L 159.5 37.154 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 14.82 31.79)",
    id: "At9Q-kL1kM0mr-w7OIgF7"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.86,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "9.58,23.25 4.3,23.24 7.88,23.25 7.48,-23.41 -0.52,8.95 -8.43,-23.41 -8,23.36 -4.25,23.36 -9.58,23.41 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 27.15 31.74)",
    id: "5zN_hUVgVkfOA6qtXnMs6"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.86,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "4.43,-23.41 4.47,21.27 1.84,23.41 -4.47,23.41 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 30.56 11.78)",
    id: "JjE-6HjbNLcisvX9yruji"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.86,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -9.009499999999996,
    y1: 0,
    x2: 9.009499999999996,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 33.61 50.78)",
    id: "0iB7DJlCrsomHc4pOSlQk"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.86,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-4.15,-1.06 -1.16,1.05 4.15,1.06 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 46.82 31.74)",
    id: "l6xiB4h7IB1X2WHwRAo0C"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "9.09,-12.7 9.14,-23.48 -9.14,-23.62 -9.11,23.62 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 46.82 38.74)",
    id: "ZwAIeORigl5gKfge2UhFJ"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-9.14,-0.38 8.91,-0.69 9.14,-3.78 9.14,3.78 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 62.1 11.9)",
    id: "Tzlr8M9VpSYEit40dtzQO"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -9.331000000000003,
    y1: 0,
    x2: 9.331000000000003,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 61.76 31.79)",
    id: "1ZipG5gto3QhqaneBMPbo"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 0.028500000000008185,
    y1: 23.63500000000002,
    x2: -0.028500000000008185,
    y2: -23.63500000000002
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 62.19 51.52)",
    id: "lRlHkdrGHGa0NRL9k7xZn"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -2.7475000000000023,
    y1: -0.03450000000000841,
    x2: 2.7475000000000023,
    y2: 0.03450000000000841
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 77.46 31.79)",
    id: "DWmqY23z9Wwe1WBXatdsE"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "9.42,23.08 3.95,23.08 6.18,23.08 -1.06,-23.08 -6.84,23.08 -9.42,23.08 -4.33,23.08 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 76.32 38.94)",
    id: "JuJQDDC8rEq6_56wacPsI"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -2.9950000000000045,
    y1: -0.046999999999997044,
    x2: 2.9950000000000045,
    y2: 0.046999999999997044
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.84 94.78 31.79)",
    id: "z1cGp0A9qbcNP7mytMu6v"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.88,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-213.28, -239.43)",
    d: "M 204.915 263.158 L 204.876 215.759 L 221.724 215.7 L 221.724 247.325 L 204.838 247.325",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.84 99.12 45.05)",
    id: "qfugXZm4AeZivQ-TugHbV"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.88,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-2.66,-7.92 2.63,-3.76 2.66,7.92 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 107.3 31.86)",
    id: "YfAeuxOXAYwXfiRRQaXfj"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "4.45,-23.55 4.47,21.41 1.84,23.55 -4.47,23.55 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 110.73 11.96)",
    id: "39nerp-_TcssNwfVYHcWY"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -8.977500000000006,
    y1: -0.07750000000000057,
    x2: 8.977500000000006,
    y2: 0.07750000000000057
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 113.77 50.79)",
    id: "dC31SAbEHJMFn6Re5_aQZ"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-4.15,-1.06 -1.16,1.05 4.15,1.06 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.8 149.97 31.66)",
    id: "agVjp0ijA-ZQJOp9yO_Cg"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.92,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "8.11,-22.4 8.11,-24.93 -7.99,-24.79 -8.11,8.34 7.82,15.22 7.86,24.93 -8.11,24.93 -8.11,20.05 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 162.35 31.92)",
    id: "T7IdLEKT61DRW0zJUKNO2"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "4.45,-23.55 4.47,21.41 1.84,23.55 -4.47,23.55 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 165.77 11.96)",
    id: "mDrAb7thXMm8j3-AszyOO"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -8.977500000000006,
    y1: -0.07750000000000057,
    x2: 8.977500000000006,
    y2: 0.07750000000000057
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.85 168.81 50.9)",
    id: "IaD7JwKbRUtWrySIVr-V7"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.87,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-4.15,-1.06 -1.16,1.05 4.15,1.06 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 181.48 31.66)",
    id: "ySa6a9zadTGXE6pHvz4I_"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "9.66,23.07 4.47,23.04 7.95,22.98 7.54,-23.09 -0.45,9.27 -8.19,-22.95 -7.61,22.77 -3.94,23.02 -9.66,23.09 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 199.69 31.62)",
    id: "I5SKPX4ptQ0AABBWzMDVo"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "8.91,17.24 8.91,23.12 -8.91,23.12 -8.91,-23.12 8.91,-23.12 8.91,-16.82 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 199.69 38.26)",
    id: "9wyxKx210bcCIONCOZxlM"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 8.914000000000016,
    y1: 0,
    x2: -8.914000000000016,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 206.37 38.29)",
    id: "ncfugcHcTAzpPz3h1fI1B"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: -0.0024999999999977263,
    y1: -2.659499999999994,
    x2: 0.0024999999999977263,
    y2: 2.659499999999994
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75 0 0 0.86 217.87 31.78)",
    id: "TZjqN6t7S-7Q1p7uZFqjU"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(97,85,228)",
      strokeWidth: 1.85,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-9.5,-23.1 -9.32,20.05 -7.34,23.11 9.36,23.11 9.5,16.72 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.20a505d2606b65e6d7048b9a76579a16.svg";
export { ForwardRef as ReactComponent };